<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          :title="$t('Tabs.tableHeading')"
          :text="$t('Tabs.tableDescription')"
        >
          <v-data-table
            :headers="headers"
            :items="items"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      :id="`automation-id-Tabs-btn-new`"
                      elevation-4
                      light
                      color="green darken-2"
                      @click="addNew()"
                      class="white--text"
                    >
                      <!-- addNew method toggles the dialog (this is included in the mixinDialogEdit mixin) -->
                      <!-- elements used for automated end to end testing needs an id: automation-id-Clinics-element-description -->
                      <v-icon>
                        mdi-plus
                      </v-icon>
                      {{ $t('Tabs.newButton')}}
                    </v-btn>
                    <v-btn
                      :id="`automation-id-Clinics-btn-refresh`"
                      @click="loadData"
                      text
                      icon
                      color="green"
                      class="float-right">
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:item.action="{ item }">
              <aurora-data-table-actions
                :items="items"
                :item="item"
                name="Metric Tabs"
                @edit="editItem"
                @delete="deleteItem"
              />
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <aurora-dialog-edit
      :show="show"
      :heading="$t('Tabs.itemHeading')"
      @cancel="show = false"
      @save="saveItem()"
    >
      <!-- show variable to control modal visibility (this is included in the mixinDialogEdit mixin) -->
      <!-- heading of the dialog box -->
      <!-- cancel handler -->
      <!-- save handler -->
      <template
        slot="form"
      >
        <!-- vue slot containing the form -->
        <v-layout
          row
          wrap
        >
          <v-form
            v-model="valid"
            lazy-validation
            style="width: 90%"
          >
            <v-text-field
              v-model="item.name"
              label="Name*"
              required
            />

            <v-text-field
              v-model="item.description"
              label="Description"
            />
          </v-form>
        </v-layout>
      </template>
    </aurora-dialog-edit>
  </v-container>
</template>

<script>
import { mixinDialogEdit, mixinOdataPage } from 'vuetify-aurora'; // mixins for basic dialog functions

const odataPage = Object.assign({}, mixinOdataPage.create('metricTabs', 'metricTab')); // generates mixin for OData page

export default {
  mixins: [mixinDialogEdit, odataPage],
  data: () => ({
    headers: [
      {
        sortable: true,
        text: 'Name',
        value: 'name',
      },
      {
        sortable: true,
        text: 'Description',
        value: 'description',
      },
      {
        sortable: false,
        text: '',
        value: 'action',
      },
    ],
    valid: false,
  }),
};
</script>

<style lang="scss" scoped>
.container.grid-list-xl .layout:not(:only-child) {
    margin: auto 0px;
}
</style>
